import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.updateActiveLink()
  }

  updateActiveLink() {
    const currentPath = window.location.pathname

    this.linkTargets.forEach((link) => {
      const icon = link.querySelector("i.fi-icon")
      const text = link.querySelector("h6")
      if (!icon || !text) return

      const linkPath = new URL(link.href).pathname

      let isActive = false

      // Special rule for Messages section
      if (linkPath.includes("index_interests_for_messages")) {
        if (
          currentPath.includes("/interests/") &&
          currentPath.includes("/messages")
        ) {
          isActive = true
        }

        if (currentPath.includes("index_interests_for_messages")) {
          isActive = true
        }
      } else {
        // Normal links
        isActive = currentPath === linkPath
      }

      if (isActive) {
        icon.classList.add("fa-active")
        icon.classList.remove("fa-grey")
        text.classList.add("text-primary")
        text.classList.remove("text-grey")
      } else {
        icon.classList.remove("fa-active")
        icon.classList.add("fa-grey")
        text.classList.remove("text-primary")
        text.classList.add("text-grey")
      }
    })
  }
}
